import { useEffect } from "react";
import { RouteComponentProps, useHistory } from "react-router";
import { useAppSelector } from "../../redux/hooks";
import { AppRoutes } from "../../constants/appRoutes";
import { LocalStorageKey, LocalStorageService } from "../../services/localStorageService";

export const ReturnLogin = () => {
    const history = useHistory();
    const { isClaimsLoaded } = useAppSelector((state) => state.userClaims);
    const localStorage = new LocalStorageService();

    useEffect(() => {
        const item = JSON.parse(localStorage.getItem(LocalStorageKey.USER_SIGNUP));
        if (!isClaimsLoaded && !item) {
            return history.push(AppRoutes.SIGNUP);
        }
    }, [isClaimsLoaded]);

    return <></>;
};

export const ReturnRequest = () => {
    const history = useHistory();
    const { isClaimsLoaded } = useAppSelector((state) => state.userClaims);
    const localStorage = new LocalStorageService();
    const { id } = useAppSelector((state) => state.detailsRequestForm.form);
    useEffect(() => {
        const item = JSON.parse(localStorage.getItem(LocalStorageKey.USER_SIGNUP));
        if (isClaimsLoaded || item) {
            if (id) {
                return history.push(AppRoutes.REQUEST_DETAILS.replace(":id", String(id)));
            } else {
                return history.push(AppRoutes.REQUEST);
            }
        }
    }, [isClaimsLoaded]);
    return <></>;
};
interface INotFoundRoute
    extends RouteComponentProps<{
        id: string;
    }> {}

export const RouteNotFound: React.FC<INotFoundRoute> = ({ match }) => {
    const history = useHistory();
    const { isClaimsLoaded } = useAppSelector((state) => state.userClaims);
    const localStorage = new LocalStorageService();
    useEffect(() => {
        const item = JSON.parse(localStorage.getItem(LocalStorageKey.USER_SIGNUP));
        if (isClaimsLoaded || item) {
            if (match.url.includes("detail")) {
                return history.push(match.url);
            } else if (match.url.includes("add")) {
                return history.push(match.url);
            } else if (match.url.includes(AppRoutes.ABOUT_SECURITY)) {
                return history.push(match.url);
            } else {
                return history.push(AppRoutes.REQUEST);
            }
        } else {
            return history.push(AppRoutes.SIGNUP);
        }
    }, [isClaimsLoaded]);

    return <> </>;
};
